import { Card } from '@zorro/design-system/v2/Card';
import { Divider } from '@zorro/design-system/v2/Divider';
import { ThemeIcon } from '@zorro/design-system/v2/ThemeIcon';
import { Group, Stack, Text } from '@zorro/web/design-system';
import { ReactElement } from 'react';

type Props = {
  icon: ReactElement;
  title: string;
  subtitle: string;
  withDivider?: boolean;
  rightSection?: ReactElement;
};

export const EmployeePagePlansCard = ({
  icon,
  title,
  subtitle,
  withDivider = false,
  rightSection,
}: Props) => {
  return (
    <Card variant="white-shadow" p="xl">
      <Stack>
        <Group>
          <ThemeIcon size="48">{icon}</ThemeIcon>
          <Stack gap={0}>
            <Text fw={600}>{title}</Text>
            <Text c="var(--color-text-default-secondary)" size="sm">
              {subtitle}
            </Text>
          </Stack>
        </Group>

        {rightSection && (
          <>
            {withDivider && <Divider />}
            <Group w="100%" justify="flex-end">
              {rightSection}
            </Group>
          </>
        )}
      </Stack>
    </Card>
  );
};
